import React from 'react';
import { Card } from './ui/card';
import { BookOpen, FileText } from 'lucide-react';

const ClinicalInsights = ({ content }) => {
  return (
    <section id="clinical-insights" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 mb-4">
              <BookOpen className="w-6 h-6 text-teal-600" />
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900">
                Clinical Insights
              </h2>
            </div>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <Card className="p-8 sm:p-12 border-slate-200 shadow-lg bg-gradient-to-br from-white to-teal-50/30">
            <div className="flex items-start space-x-4 mb-6">
              <div className="p-3 bg-teal-100 rounded-lg">
                <FileText className="w-6 h-6 text-teal-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-slate-900 mb-4">Coming Soon</h3>
                <p className="text-lg text-slate-700 leading-relaxed">
                  {content?.description}
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ClinicalInsights;